import Drawer from '@/components/drawer'
import { BREAKPOINTS } from '@/core/breakpointsController'

export default class MobileMenuDrawer extends Drawer {
  static TYPE = 'mobile-menu-drawer'

  constructor(el: HTMLElement) {
    super(el, {
      maxBreakpoint: BREAKPOINTS.md,
      backdropOptions: {
        title: 'Close mobile menu'
      }
    })
  }
}
